import React from 'react';

import { TextField } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { Control, FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';

import { PasswordPanelShared } from '@liscio/common';

import { BiometricsAdornment } from '../../BiometricsAdornment/BiometricsAdornment';
import { BiometricsToggle } from '../../BiometricsToggle/BiometricsToggle';
import { RememberMeToggle } from '../../RememberMe/RememberMeToggle';
import { LoginFormInterface } from '../SignInForm';
import { Link, PasswordInput } from 'components';

interface PasswordPanelProps {
  isLoading: boolean;
  register: UseFormRegister<LoginFormInterface>;
  errors: FieldErrors<FieldValues>;
  control: Control<LoginFormInterface>;
  updateRememberMeEmailValue: (email: string) => void;
  captureForgotPasswordEmail: () => void;
}

export const PasswordPanel = ({
  isLoading,
  register,
  errors,
  control,
  updateRememberMeEmailValue,
  captureForgotPasswordEmail,
}: PasswordPanelProps) => {
  return (
    <PasswordPanelShared
      isLoading={isLoading}
      control={control as unknown as Control<FieldValues>}
      updateRememberMeEmailValue={updateRememberMeEmailValue}
      captureForgotPasswordEmail={captureForgotPasswordEmail}
      credentialsFields={(
        <>
          <TextField
            {...register('email')}
            fullWidth
            type="email"
            autoComplete="username webauthn"
            placeholder="Email"
            inputProps={{ 'aria-label': 'Email' }}
            error={Boolean(errors?.email)}
            helperText={errors?.email?.message as string}
            disabled={isLoading}
            InputProps={{
              endAdornment: <BiometricsAdornment />,
            }}
          />
          <PasswordInput
            {...register('password')}
            fullWidth
            placeholder="Password"
            error={Boolean(errors?.password)}
            helperText={errors?.password?.message as string}
            disabled={isLoading}
          />
        </>
      )}
      submitLabel="Sign In"
      forgotPasswordTo="/authenticate/forgot-password"
      forgotPasswordColor={(theme: Theme) => theme.palette.primary.main}
      RememberMeToggleComponent={RememberMeToggle}
      BiometricsToggleComponent={BiometricsToggle}
      LinkComponent={Link}
      submitButtonBeforeOptions
    />
  );
};
